module.exports = {
  Description: {
    StaticInfo: `<p>The execution of the operations is the Project Phase where all planning becomes a reality. </p>
      <p>Although a compilation of Practices for Monitoring Operations is provided, if the Client requires and authorizes it, at the time of execution of the operations, an EGEP consultant can and will provide the monitoring and necessary recommendations so that the activities are carried out optimally and safely, reducing the associated risk, and adding value to the operations, and to the client. Support can be on-site with an EGEP representative, online using the company services real time monitoring system or by phone directly with the client, being available 24/7</p>`,
    SectionsInfo: []
  },
  Overview: {
    StaticInfo: `
      <p>Job performance is the key to success in fracturing jobs because it involves significant investment in equipment, materials and personnel. Executing a hydraulic fracturing job is an expensive and complex operation because it involves problems of different nature. Typical logistical challenges include the physical preparation of the well-site, equipment, and materials before starting the job. Other problems are related to operational events such as equipment malfunction during the job.</p>
    <p>During field operations, the client, or the technical personnel who represents him, together with the service company representative, must carry out an objective review of HSEQ rules, tanks, fluids, pumps and equipment that will be used in the operation, to guarantee that they conform to the requirements and specifications</p>
    <p>Modern hydraulic-fracturing treatments are operationally complex, equipment intensive, and personnel dependent. Even the best-planned treatments experience unforeseen problems, and are often handicapped by electrical and equipment failures. However, when there are competent, knowledgeable personnel on location that have pride in their service quality and equipment performance, then most problems can be overcome. Attitude and experience are deciding factors.</p>
    <p>The service providers are professionals commited to deliver the best service possible and will always perform better with support from their District and operating-company representatives.</p>
      `,
    SectionsInfo: [{
      title: "Common mechanical problems during hydraulic-fracturing operations could include",
      content: `
          <ul>
      <li>Equipment nonproductive time, mainly in the blender and pumps</li>
      <li>Equipment malfunction including erratic or noncalibrated densitometer, equipment communication with the data van</li>
      <li>Job-monitoring software crashing</li>
      <li>Failed pressure tests</li>
      <li>Casing tight spots</li>
      <li>Offset-well communication with fracture hits</li>
    </ul>
          `
    },
    {
      title: "Common rheological and proppant-concentration problems during hydraulic-fracturing operations could include",
      content: `
        <ul>
      <li>Water supply</li>
      <li>Chemical compatibility and liquid-additive pumps</li>
      <li>Timely inventory resupply</li>
      <li>Cold weather freezing treating, equipment and the wellhead, and rain getting the sand wet</li>
    </ul>
        `
    },
    {
      title: "Common third-party problems, typically during multiwell fracturing operations, could include",
      content: `
        <ul>
        <li>Communication among all service providers</li>
        <li>Manifold valves washing out</li>
        <li>Wireline delays from missed runs or gel/sand in the wellbore preventing guns being pumped down</li>
      </ul>
        `
    },
    {
      title: "Hydraulic fracturing pre-job safety-meeting checklist",
      content: `
    <strong>Personnel Safety</strong>
    <ul>
      <li>All personnel on location must attend the safety meeting and sign the safety meeting sheet</li>
      <li>Ensure all personnel are fit for duty (i.e., alert, hydrated, etc.)</li>
      <li>Identify acute allergies (bees, peanuts, etc.) and response plan</li>
      <li>Ensure personal protective equipment (PPE) requirements</li>
      <li>Complete and sign job hazard assessment for planned work</li>
      <li>Review chemical and hazardous materials safety data sheets</li>
      <li>
        Ensure there is proper fall protection (required when working at heights)
      </li>
      <li>Review signs/symptoms of heat stress and importance of staying hydrated</li>
      <li>Ensure there are required spotters available when moving equipment on location</li>
      <li>Ensure sour gas/H2S meters are current and working</li>
    </ul><br>
    <strong>Job Procedure and Pumping Pressure</strong>
    <ul>
      <li>Outline of job, anticipated rates and pressures</li>
      <li>Define maximum pressure and pump shutdown procedures, procedures for loss of the blender (emergency flush procedures)</li>
      <li>Review pressure test and function test procedures</li>
      <li>Review wellhead, bleedoff, flowback, and valve status</li>
      <li>Review and identify duty assignments and line of communication for personnel</li>
    </ul><br>
    <strong>Emergency Procedures</strong>
    <ul>
      <li>Review head-count procedures in master protocol to achieve expedite count and identify missing personnel; use buddy system.</li>
      <li>Review and identify escape routes (H2S, fire, pressure release, etc.), master area, and head-count recap Identify emergency vehicle, driver, and directions to emergency facility, including correct emergency number and location coordinates to provide to emergency providers</li>
      <li>Know the location of eyewash station, portable shower, cooling area, windsock, first-aid kit, and automated external defibrillator Note: Eyewash station and portable shower should be tested daily</li>
      <li>Ensure there is a contingency plan in place, if communications fail</li>
      <li>Review fire-extinguisher placement and verify fire-extinguisher inspection tags</li>
      <li>Establish well-control valve assignments, including pressure-bleedoff valves and shut-in valves</li>
      <li>Establish tolerances for inclement weather (wind speed, proximity of lightning, temperature, and precipitation)</li>
    </ul><br>
    
    <strong>Location Safety</strong>
    <ul>
      <li>Identify, secure, and rope off high-pressure pumping lines</li>
      <li>Ensure RED zone is marked off, and caution bystanders to stay clear or in designated areas while pumping</li>
      <li>Confirm radio silence and prohibit cell-phone use when perforating</li>
      <li>Identify designated smoking area</li>
      <li>Follow location specific lock-out/tag-out procedures</li>
      <li>Communicate and inform all personnel about tasks being performed on location: pressure testing, pumping, crane movement, etc.</li>
      <li>Outline all visible/audible signs used on location for elevated-risk tasks (flags, strobe lights, horn blasts, and sirens)</li>
    </ul><br>
    <strong>Hydraulic fracturing QA/QC checklist</strong>
    <strong>Pre-Job Procedures</strong>
    <ul>
      <li>Ensure proper procedure is used for fluid type, rate, and volumes as well as proppant type and amount</li>
      <li>Verify correct fluid additives and proppant concentrations are on the mass-balance sheet</li>
      <li>Ensure adequate quantities of fluid, proppant, and chemicals are available for treatment</li>
      <li>Verify tubular parameters, adequate high-pressure tubular size, placement for treatment design, and inspection expiration dates</li>
      <li>Verify perforation and treatment schedule and ensure that service-company/site supervisors have the most up-to-date procedure</li>
      <li>Ensure adequate hydraulic horsepower (HHP), with excess margin for designed treatment</li>
      <li>Verify expected treating pressure, maximum treating pressure, and emergency procedures for pressure-relief valves (pump kickouts and pop-off)</li>
      <li>Ensure adequate number of pressure transducers, including an annulus transducer and a minimum of two transducers in treating lines</li>
      <li>Verify correct primary and auxiliary equipment for treatment is rigged up and functional</li>
      <li>Review emergency flush procedures with appropriate personnel and ensure backup system is rigged up</li>
      <li>Ensure calibration of pressure transducers, flowmeters, radioactive densitometers, viscosimeters, and pH probes</li>
      <li>Verify chemical-additive location of entry into fluid stream (blender suction/tub/discharge, hydration)</li>
      <li>Verify surface line and flush volumes</li>
      <li>Discuss designed treatment with other personnel in supervisory roles and review contingency plans</li>
      <li>Verify well and stage order</li>
      <li>Ensure all personnel are in position and ready before opening well</li>
    </ul><br>
    <strong>Pre-Job QC</strong>
    <ul>
      <li>Ensure sieve analysis was performed on each proppant and that each sample meets minimum specification requirements</li>
      <li>Ensure water QC tests are performed on each tank and meet minimum specifications for treatment fluids</li>
      <li>Ensure adequate gel testing is performed on each tank (hydration, crosslink, and breaker) with location of chemicals and tank water</li>
      <li>If necessary, confirm fluid system can achieve adequate viscosity and strength under well conditions. (i.e., ambient temperature, reservoir temperature, closure pressure, pipe time, etc.)</li>
      <li>Ensure all primary and backup chemical pumps and dry-additive pumps are calibrated and bucket tested</li>
      <li>Test liquid-additive (LA) pumps at expected parameters (concentration and rate)</li>
      <li>Record starting quantities of all fluid, chemicals, and proppant</li>
      <li>Double-check the data stream, and bump test each chemical to ensure it is coming through on the correct data channel</li>
      <li>Ensure all surface tubulars, wheel valves, check valves, manifold valves, and pop-off valves are successfully pressure tested and up to date on certification</li>
    </ul><br>
    <strong>During the Job</strong>
    <ul>
      <li>Monitor and record job rates, volumes, pressures, and proppant density; take corrective action as necessary</li>
      <li>Use proppant schematic to monitor proppant usage through bins; compare pumped mass on tickets to densitometer</li>
      <li>If applicable, sample gel and proppant-laden fluid to verify viscosity, pH, and crosslink time regularly; verify high-viscosity friction reducer samples for viscosity</li>
      <li>Ensure correct concentrations of chemical additives are being used</li>
      <li>Communicate critical changes with appropriate personnel when the scope of the work changes and take remedial action</li>
      <li>if necessary set the line of communication between service companies and ensure consistency to alleviate risk and drive efficiency</li>  
    </ul><br>
    <strong>After the Job</strong>
    <ul>
      <li>Ensure correct volumes of fluid, chemicals, and proppant were used</li>
      <li>Provide post-job critique with corrective actions</li>
      <li>Communicate treatment parameters to appropriate personnel</li>
      <li>Review stage invoice for proper accounting of materials used, HHP, and other cost items</li>
    </ul><br>
    <strong>After the Job is completed, be sure to keep records and verify:</strong>
    <p>All rates, pressures, and final inventories and communicate key job parameters to appropriate personnel. </p>
    <ul>
      <li>Verify proppant, chemical, and fluid totals are within acceptable variance</li>
      <li>Obtain all digital files and hard copies of the treatment</li>
      <li>Record all key-performance-indicator data</li>
      <li>Others common topics to discuss include: </li>
      <ul>
        <li>Personnel issues</li>
        <li>Treating fluids and proppant</li>
        <li>Pump maintenance and blender performance</li>
        <li>Treating tubulars</li>
        <li>Inventory including chemicals, proppant, and fuel</li>
      </ul>
    </ul><br>
    <p>To ensure continuous improvement and knowledge transfer, provide post-job critique to service provider with suggested areas of improvement and discuss job problems, remedies, and corrective actions. This is to ensure improved execution in subsequent wells or stages. </p>
    <p>Review stage invoices for material usage, HHP, and other ticketed items to accurately reflect field charges to simplify the final invoicing process. If applicable, review upcoming jobs, any procedural changes, corrective actions, and equipment-maintenance and move schedule. Request a detailed and precise post-job report to company representatives.</p>
    <strong>Attend the post-job safety meeting held with everyone on location and</strong>
    <ul>
      <li>Discuss observations about job safety</li>
      <li>Discuss and document any near-misses</li>
      <li>Review rig-down procedures and job assignments</li>
      <li>Ensure location is free from trash and debris and report and clean-up any spills</li>
      <li>Review return travel plans and convoy policy, and reiterate any speed limits</li>
    </ul><br>`
    }
    ]
  }
}